import { useEffect, useCallback } from 'react';
import { PdfProcessedEvent } from '../types/pushNotifications';
import { getBrowserSessionId } from '@urbanx/agx.auth.client';

type PdfProcessedEventListener = (event: PdfProcessedEvent) => void;
const pdfProcessedEventListeners = new Set<PdfProcessedEventListener>();

export const emitPdfProcessedEvent = (pdfEvent: PdfProcessedEvent) => {
  if (pdfEvent.sessionId !== getBrowserSessionId()) return;
  pdfProcessedEventListeners.forEach((listener) => listener(pdfEvent));
};

export const usePdfProcessedEvent = (
  onPdfProcessedEvent: (pdfEvent: PdfProcessedEvent) => void
) => {
  const handlePdfProcessedEvent = useCallback(
    (pdfEvent: PdfProcessedEvent) => {
      onPdfProcessedEvent(pdfEvent);
    },
    [onPdfProcessedEvent]
  );

  useEffect(() => {
    // Subscribe to pdf processed
    pdfProcessedEventListeners.add(handlePdfProcessedEvent);

    return () => {
      // Cleanup: Unsubscribe when component unmounts
      pdfProcessedEventListeners.delete(handlePdfProcessedEvent);
    };
  }, [handlePdfProcessedEvent]);

  // TODO: Add utility functions or state here if needed
  return {
    // Add any return values here
  };
};
